import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  possessiveCelebratedName: PropTypes.string.isRequired,
};

const NullState = ({ possessiveCelebratedName }) => {
  return (
    <div className="text-center">
      <img
        src={getAsset('/gift-colored-combo.svg')}
        width="60px"
        height="60px"
        className="mb-2"
        alt="Gift"
      />
      <h2 className="mb-1">{possessiveCelebratedName} Waldo wishlist</h2>
      <p className="text-light">
        Select the items you&apos;d like to buy as a gift for the couple!
      </p>
      <p>No items available for gifting.</p>
    </div>
  );
};

NullState.propTypes = propTypes;

export default NullState;
